webpackJsonp([5],{

/***/ 1563:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1614)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1599),
  /* template */
  __webpack_require__(1652),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1599:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Integrations',
  computed: {
    isBasePage: function isBasePage() {
      return this.$route.name === 'Integrations';
    }
  }
});

/***/ }),

/***/ 1607:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1555)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"index.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 1614:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1607);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1556)("3981a380", content, true, {});

/***/ }),

/***/ 1652:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "extended": !_vm.isBasePage
    }
  }, [_c('v-toolbar-title', [_vm._v("\n      " + _vm._s(_vm.$route.name) + "\n    ")]), _vm._v(" "), (!_vm.isBasePage) ? _c('template', {
    slot: "extension"
  }, [_c('v-btn', {
    staticClass: "pl-0",
    attrs: {
      "to": "/integrations/",
      "small": "",
      "flat": "",
      "text": ""
    }
  }, [_vm._v("Integrations")]), _vm._v(" "), _c('v-icon', [_vm._v("chevron_right")]), _vm._v("\n      " + _vm._s(_vm.$route.name) + "\n    ")], 1) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.$route.meta.installHelp) ? _c('v-btn', {
    attrs: {
      "small": "",
      "outline": "",
      "target": "_blank",
      "color": "info",
      "href": _vm.$route.meta.installHelp
    }
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "small": ""
    }
  }, [_vm._v("info")]), _vm._v("\n      Help "), _c('v-icon', {
    staticClass: "ml-1",
    attrs: {
      "small": "",
      "small": ""
    }
  }, [_vm._v("open_in_new")])], 1) : _vm._e()], 2), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/5.589313f361dda6d73a68.js